/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Preferedothersubject2Inputs */

const de__field_preferedothersubject2 = /** @type {(inputs: _Field_Preferedothersubject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugtes anderes Fach`)
};

/**

* @param {_Field_Preferedothersubject2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_preferedothersubject2 = /** @type {((inputs?: _Field_Preferedothersubject2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Preferedothersubject2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_preferedothersubject2(inputs)
});
export { _field_preferedothersubject2 as "_field_preferedOtherSubject" }